<div class="loader-wrapper">
    <app-loader [isBusy]="isBusy">
        <ng-template>
            <kendo-grid
                class="mb-2"
                [resizable]="true"
                [data]="itemsGridView"
                [skip]="itemPage.skip"
                [pageSize]="itemPage.pageSize"
                [pageable]="pagingOptions"
                [sort]="sort"
                [sortable]="{ allowUnsort: allowUnsort, mode: multiple ? 'multiple' : 'single' }"
                [selectable]="selectableSettings"
                [kendoGridSelectBy]="selectionCallback"
                [selectedKeys]="selected"
                [rowSelected]="isRowSelected"
                (pageChange)="pageChange($event, emailNotifications)"
                (sortChange)="sortChange($event, emailNotifications)"
                (selectedKeysChange)="keyChange($event)">
                @if (editMode === true) {
                    <ng-template kendoGridToolbarTemplate>
                        @if (showEmailEventDropdown && dropdownItems.length > 0) {
                            <dropdown-add
                                floatingLabelText="Email Event"
                                [codeListValues]="dropdownItems"
                                [displayProperty]="'name'"
                                [allowDuplicates]="false"
                                [includeExpirationDate]="false"
                                (eventTriggered)="addEmailSubscription($event)"></dropdown-add>
                        }
                        <button
                            class="btn btn-sm btn-primary ml-2"
                            [disabled]="!subscribeButtonDisabled()"
                            (click)="subscribeToEmail()">
                            <fa-icon [icon]="['fas', 'bell']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Subscribe' | translate }}
                        </button>
                        <button
                            class="btn btn-sm btn-secondary ml-2"
                            [disabled]="!unsubscribeButtonDisabled()"
                            (click)="unsubscribeToEmail()">
                            <fa-icon [icon]="['fas', 'bell-slash']"></fa-icon>
                            &nbsp;&nbsp;{{ 'Unsubscribe' | translate }}
                        </button>
                    </ng-template>
                }
                @if (editMode === true) {
                    <kendo-grid-checkbox-column [showSelectAll]="true" [width]="50"></kendo-grid-checkbox-column>
                }
                <kendo-grid-column
                    title="{{ 'Notification Type' | translate }}"
                    field="notificationType"
                    [width]="300"></kendo-grid-column>
                <kendo-grid-column
                    title="{{ 'Subscribed' | translate }}"
                    field="active"
                    [width]="300"
                    [headerClass]="'centerColumn'">
                    <ng-template let-row kendoGridCellTemplate>
                        <input type="checkbox" kendoCheckBox disabled [checked]="row.active" />
                    </ng-template>
                </kendo-grid-column>
                <ng-template kendoGridNoRecordsTemplate>
                    <p>{{ 'No records available' | translate }}.</p>
                </ng-template>
            </kendo-grid>
        </ng-template>
    </app-loader>
</div>
